import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import activities from './activities';
import activityGroups from './activityGroups';
import articulationGymnasticsCollections from './articulationGymnasticsCollections';
import articulationGymnasticsLevels from './articulationGymnasticsLevels';
import authentication from './authentication';
import climbStepOneCollections from './climbStepOneCollections';
import climbStepOneExtraCollections from './climbStepOneExtraCollections';
import climbStepOneExtraLevels from './climbStepOneExtraLevels';
import climbStepOneLevels from './climbStepOneLevels';
import climbStepThreeCollections from './climbStepThreeCollections';
import climbStepThreeLevels from './climbStepThreeLevels';
import climbStepThreeExtraCollections from './climbStepThreeExtraCollections';
import climbStepThreeExtraLevels from './climbStepThreeExtraLevels';
import climbStepTwoCollections from './climbStepTwoCollections';
import climbStepTwoLevels from './climbStepTwoLevels';
import climbStepTwoExtraCollections from './climbStepTwoExtraCollections';
import climbStepTwoExtraLevels from './climbStepTwoExtraLevels';
import coupons from './coupons';
import dailyMap from './dailyMap';
import discoverStepOneCollections from './discoverStepOneCollections';
import discoverStepOneExtraCollections from './discoverStepOneExtraCollections';
import discoverStepOneExtraLevels from './discoverStepOneExtraLevels';
import discoverStepOneLevels from './discoverStepOneLevels';
import discoverStepThreeCollections from './discoverStepThreeCollections';
import discoverStepThreeLevels from './discoverStepThreeLevels';
import discoverStepThreeExtraCollections from './discoverStepThreeExtraCollections';
import discoverStepThreeExtraLevels from './discoverStepThreeExtraLevels';
import discoverStepTwoCollections from './discoverStepTwoCollections';
import discoverStepTwoLevels from './discoverStepTwoLevels';
import discoverStepTwoExtraCollections from './discoverStepTwoExtraCollections';
import discoverStepTwoExtraLevels from './discoverStepTwoExtraLevels';
import feedback from './feedback';
import findWordsStepOneCollections from './findWordsStepOneCollections';
import findWordsStepOneExtraCollections from './findWordsStepOneExtraCollections';
import findWordsStepOneExtraLevels from './findWordsStepOneExtraLevels';
import findWordsStepOneLevels from './findWordsStepOneLevels';
import findWordsStepThreeCollections from './findWordsStepThreeCollections';
import findWordsStepThreeLevels from './findWordsStepThreeLevels';
import findWordsStepThreeExtraCollections from './findWordsStepThreeExtraCollections';
import findWordsStepThreeExtraLevels from './findWordsStepThreeExtraLevels';
import findWordsStepTwoCollections from './findWordsStepTwoCollections';
import findWordsStepTwoLevels from './findWordsStepTwoLevels';
import findWordsStepTwoExtraCollections from './findWordsStepTwoExtraCollections';
import findWordsStepTwoExtraLevels from './findWordsStepTwoExtraLevels';
import flashCardsStepOneCollections from './flashCardsStepOneCollections';
import flashCardsStepOneExtraCollections from './flashCardsStepOneExtraCollections';
import flashCardsStepOneExtraLevels from './flashCardsStepOneExtraLevels';
import flashCardsStepOneLevels from './flashCardsStepOneLevels';
import flashCardsStepThreeCollections from './flashCardsStepThreeCollections';
import flashCardsStepThreeLevels from './flashCardsStepThreeLevels';
import flashCardsStepThreeExtraCollections from './flashCardsStepThreeExtraCollections';
import flashCardsStepThreeExtraLevels from './flashCardsStepThreeExtraLevels';
import flashCardsStepTwoCollections from './flashCardsStepTwoCollections';
import flashCardsStepTwoLevels from './flashCardsStepTwoLevels';
import flashCardsStepTwoExtraCollections from './flashCardsStepTwoExtraCollections';
import flashCardsStepTwoExtraLevels from './flashCardsStepTwoExtraLevels';
import help from './help';
import licensing from './licensing';
import memoryStepOneCollections from './memoryStepOneCollections';
import memoryStepOneExtraCollections from './memoryStepOneExtraCollections';
import memoryStepOneExtraGroups from './memoryStepOneExtraGroups';
import memoryStepOneExtraLevels from './memoryStepOneExtraLevels';
import memoryStepOneGroups from './memoryStepOneGroups';
import memoryStepOneLevels from './memoryStepOneLevels';
import memoryStepThreeCollections from './memoryStepThreeCollections';
import memoryStepThreeGroups from './memoryStepThreeGroups';
import memoryStepThreeLevels from './memoryStepThreeLevels';
import memoryStepThreeExtraCollections from './memoryStepThreeExtraCollections';
import memoryStepThreeExtraGroups from './memoryStepThreeExtraGroups';
import memoryStepThreeExtraLevels from './memoryStepThreeExtraLevels';
import memoryStepTwoCollections from './memoryStepTwoCollections';
import memoryStepTwoGroups from './memoryStepTwoGroups';
import memoryStepTwoLevels from './memoryStepTwoLevels';
import memoryStepTwoExtraCollections from './memoryStepTwoExtraCollections';
import memoryStepTwoExtraGroups from './memoryStepTwoExtraGroups';
import memoryStepTwoExtraLevels from './memoryStepTwoExtraLevels';
import notes from './notes';
import notifications from './notifications';
import pagination from './pagination';
import paintingCollections from './paintingCollections';
import paintingGroups from './paintingGroups';
import paintingLevels from './paintingLevels';
import parrot from './parrot';
import payment from './payment';
import readAndThinkBonusLevels from './readAndThinkBonusLevels';
import readAndThinkCollections from './readAndThinkCollections';
import readAndThinkLevels from './readAndThinkLevels';
import readTogetherBonusLevels from './readTogetherBonusLevels';
import readTogetherCollections from './readTogetherCollections';
import readTogetherLevels from './readTogetherLevels';
import replenishmentCollections from './replenishmentCollections';
import replenishmentLevels from './replenishmentLevels';
import speechSounds from './speechSounds';
import student from './student';
import students from './students';
import subactivities from './subactivities';
import subscriptionStatus from './subscriptionStatus';
import subscriptions from './subscriptions';
import tooltips from './tooltips';
import treasureHuntCollections from './treasureHuntCollections';
import treasureHuntGroups from './treasureHuntGroups';
import treasureHuntLevels from './treasureHuntLevels';
import user from './user';
import wallet from './wallet';
import wheelOfFortuneCollections from './wheelOfFortuneCollections';
import wheelOfFortuneLevels from './wheelOfFortuneLevels';
import actions from '../../constants/actions';

const staticReducers = {
  activities,
  activityGroups,
  articulationGymnasticsCollections,
  articulationGymnasticsLevels,
  authentication,
  climbStepThreeCollections,
  climbStepThreeLevels,
  climbStepThreeExtraCollections,
  climbStepThreeExtraLevels,
  climbStepTwoCollections,
  climbStepTwoLevels,
  climbStepTwoExtraCollections,
  climbStepTwoExtraLevels,
  climbStepOneCollections,
  climbStepOneLevels,
  climbStepOneExtraCollections,
  climbStepOneExtraLevels,
  coupons,
  dailyMap,
  discoverStepThreeCollections,
  discoverStepThreeLevels,
  discoverStepTwoCollections,
  discoverStepTwoLevels,
  discoverStepOneCollections,
  discoverStepOneLevels,
  discoverStepOneExtraCollections,
  discoverStepOneExtraLevels,
  discoverStepTwoExtraCollections,
  discoverStepTwoExtraLevels,
  discoverStepThreeExtraCollections,
  discoverStepThreeExtraLevels,
  feedback,
  findWordsStepThreeCollections,
  findWordsStepThreeLevels,
  findWordsStepThreeExtraCollections,
  findWordsStepThreeExtraLevels,
  findWordsStepTwoCollections,
  findWordsStepTwoLevels,
  findWordsStepTwoExtraCollections,
  findWordsStepTwoExtraLevels,
  findWordsStepOneCollections,
  findWordsStepOneLevels,
  findWordsStepOneExtraCollections,
  findWordsStepOneExtraLevels,
  flashCardsStepThreeCollections,
  flashCardsStepThreeLevels,
  flashCardsStepThreeExtraCollections,
  flashCardsStepThreeExtraLevels,
  flashCardsStepTwoCollections,
  flashCardsStepTwoLevels,
  flashCardsStepOneCollections,
  flashCardsStepOneLevels,
  flashCardsStepOneExtraCollections,
  flashCardsStepOneExtraLevels,
  flashCardsStepTwoExtraCollections,
  flashCardsStepTwoExtraLevels,
  help,
  licensing,
  memoryStepThreeCollections,
  memoryStepThreeGroups,
  memoryStepThreeLevels,
  memoryStepThreeExtraCollections,
  memoryStepThreeExtraGroups,
  memoryStepThreeExtraLevels,
  memoryStepTwoCollections,
  memoryStepTwoGroups,
  memoryStepTwoLevels,
  memoryStepTwoExtraCollections,
  memoryStepTwoExtraGroups,
  memoryStepTwoExtraLevels,
  memoryStepOneCollections,
  memoryStepOneGroups,
  memoryStepOneLevels,
  memoryStepOneExtraCollections,
  memoryStepOneExtraGroups,
  memoryStepOneExtraLevels,
  notes,
  notifications,
  pagination,
  paintingCollections,
  paintingGroups,
  paintingLevels,
  parrot,
  payment,
  readAndThinkBonusLevels,
  readAndThinkCollections,
  readAndThinkLevels,
  readTogetherBonusLevels,
  readTogetherCollections,
  readTogetherLevels,
  replenishmentCollections,
  replenishmentLevels,
  speechSounds,
  student,
  students,
  subactivities,
  subscriptions,
  subscriptionStatus,
  tooltips,
  treasureHuntCollections,
  treasureHuntGroups,
  treasureHuntLevels,
  user,
  wallet,
  wheelOfFortuneCollections,
  wheelOfFortuneLevels,
};

const rootReducer = (asyncReducers) => {
  const appReducer = combineReducers({
    ...staticReducers,
    ...asyncReducers,

    routing: routerReducer,
  });

  return (state, action) => {
    if (action?.type === actions.CLEAR_USER_STORE_DATA) {
      // eslint-disable-next-line no-param-reassign
      state = undefined;
    }

    return appReducer(state, action);
  };
};

export default rootReducer;
